<template>
  <div v-if="$can('update','jobs')">
    <b-card>
      <form v-on:submit.prevent="formSubmitted" enctype="multipart/form-data">
      <!-- accoint details tab -->
            <b-row>
              <b-col
                cols="12"
                class="mb-2"
              >
                <h5 class="mb-0">
                  Job Details
                </h5>
                <small class="text-muted" v-if="form.jobId">
                  Job ID : {{ form.jobId }}
                </small>
              </b-col>

              <b-col
                md="4"
                xl="4"
                xs="6"
                class="mb-1"
              >
                <b-form-group
                  label="Job Skill *"
                  label-for="jobTitle"
                >
                    <b-form-input
                      id="job-title"
                      v-model="form.jobTitle"
                      class="text-capitalize"
                      type="text"
                      placeholder="FPNA/Python Developer/Java Developer"
                      ref="title"
                    />
                    <small v-if="!form.jobTitle" class="text-danger">{{ error.title }}</small>
                  
                </b-form-group>
              </b-col>
              <b-col
                md="3"
                xl="3"
                xs="6"
                class="mb-1"
              >
                <b-form-group
                  label="Position Type *"
                  label-for="position"
                >
                  
                    <b-form-group ref="position">
                      <v-select
                        v-model="form.type"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        label="title"
                        :options="jobTypeOptions"
                        :reduce="(option) => option.title"
                        :disabled="form.type === 'Contractual' || form.type === 'Cost Plus' ? true : false"
                      />
                    </b-form-group>
                  <small v-if="!form.type"  class="text-danger">{{ error.type }}</small>
                  
                </b-form-group>
              </b-col>
              <b-col
                md="3"
                xl="3"
                xs="6"
                class="mb-1"
              >
                <b-form-group
                  label="Job Role"
                  label-for="jobRole"
                >
                    <b-form-input
                      id="job-role"
                      v-model="form.role"
                      class="text-capitalize"
                      type="text"
                      placeholder="Job Role"
                      ref="title"
                    />
                    
                </b-form-group>
              </b-col>
              <b-col
                md="2"
                xl="2"
                xs="6"
                class="mb-1"
              >
                <b-form-group
                  label="Job Band/Job Level"
                  label-for="jobBand"
                >
                    <b-form-input
                      id="job-band"
                      v-model="form.jobBand"
                      class="text-capitalize"
                      type="text"
                      placeholder="Job Band"
                      ref="title"
                    />
                   
                </b-form-group>
              </b-col>
              
              <b-col
                md="3"
                xl="3"
                xs="6"
                class="mb-1"
              >
                <b-form-group
                  label="Client *"
                  label-for="client"
                >
                  
                    <b-form-group ref="client">
                      <v-select
                        v-model="form.clientSelected"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        label="title"
                        :options="clients"
                        
                      />
                    </b-form-group>
                  <small v-if="!form.clientSelected"  class="text-danger">{{ error.client }}</small>
                  
                </b-form-group>
              </b-col>
              <b-col
                md="3"
                xl="3"
                xs="6"
                class="mb-1"
                v-if="isKPMGRPOClient"
              >
                <b-form-group
                  label="Business *"
                  label-for="business"
                >
                    <b-form-group ref="business">
                      <v-select
                        v-model="form.business"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        label="title"
                        :options="businessOptions"
                        placeholder="Select Business"
                        
                      />
                    </b-form-group>
                  <small v-if="!hasSelectedBusiness" class="text-danger">{{ error.business }}</small>
                </b-form-group>
              </b-col>
              <b-col
                md="3"
                xl="3"
                xs="6"
                class="mb-1"
                v-if="isKPMGRPOClient && hasSelectedBusiness && filteredSubBusinessOptions.length > 0"
              >
                <b-form-group
                  label="Sub Business"
                  label-for="subBusiness"
                >
                    <b-form-group ref="subBusiness">
                      <v-select
                        v-model="form.subBusiness"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        label="title"
                        :options="filteredSubBusinessOptions"
                        multiple
                        placeholder="Select Sub Business"
                        
                      />
                    </b-form-group>
                </b-form-group>
              </b-col>
              <b-col
                md="3"
                xl="3"
                xs="6"
                class="mb-1"
              >
                <b-form-group
                  label="Job Domain *"
                  label-for="jobDomain"
                >
                
                  <b-form-group>
                    <v-select
                      v-model="form.domainSelected"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="title"
                      :options="domains"
                      ref="domain"
                      style="overflow-x: visible"
                    />
                  </b-form-group>
                  <small v-if="!form.domainSelected" class="text-danger">{{ error.domain }}</small>
                
                </b-form-group>
              </b-col>

              <!-- Job Function for Reliance & Reliance RPO -->
              <b-col
                md="3"
                xl="3"
                xs="6"
                class="mb-1"
                v-if="isRelianceClient"
              >
                <b-form-group
                  label="Job Function *"
                  label-for="jobFunction"
                >
                  <b-form-group ref="jobFunction">
                    <v-select
                      v-model="form.jobFunction"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="title"
                      :options="jobFunctionOptions"
                      placeholder="Select Job Function"
                    />
                  </b-form-group>
                  <small v-if="isRelianceClient && !form.jobFunction" class="text-danger">{{ error.jobFunction }}</small>
                </b-form-group>
              </b-col>
              <!-- Drive Dates for Reliance RPO (multi-date) -->
              <b-col
                md="4"
                xl="4"
                xs="12"
                class="mb-1"
                v-if="isRelianceClient"
              >
                <b-form-group
                  label="Drive Date(s)"
                  label-for="driveDates"
                >
                  <div
                    v-for="(d, i) in form.driveDates"
                    :key="i"
                    class="d-flex align-items-center mb-50"
                    style="gap:6px;"
                  >
                    <b-form-input
                      :value="d"
                      type="date"
                      @change="(val) => { $set(form.driveDates, i, val); updateDriveName() }"
                    />
                    <b-button
                      variant="flat-danger"
                      size="sm"
                      class="btn-icon"
                      @click="removeDriveDate(i)"
                    >
                      <feather-icon icon="XIcon" size="14" />
                    </b-button>
                  </div>
                  <b-button
                    variant="outline-primary"
                    size="sm"
                    class="mt-50"
                    @click="addDriveDate"
                  >
                    <feather-icon icon="PlusIcon" size="13" class="mr-25" />Add Date
                  </b-button>
                </b-form-group>
              </b-col>
              <b-col
                md="3"
                xl="3"
                xs="6"
                class="mb-1"
                v-if="isRelianceClient"
              >
                <b-form-group
                  label="Drive Name *"
                  label-for="driveName"
                >
                  <b-form-input
                    v-model="form.driveName"
                    placeholder="Drive name (auto-filled)"
                    type="text"
                    ref="driveName"
                    disabled
                  />
                  <small v-if="error.driveName" class="text-danger">{{ error.driveName }}</small>
                </b-form-group>
              </b-col>
              <b-col
                md="3"
                xl="3"
                xs="6"
                class="mb-1"
                v-if="isRelianceClient"
              >
                <b-form-group
                  label="Position Submission Date"
                  label-for="positionSubmissionDate" 
                >
                  <b-form-input
                    v-model="form.positionSubmissionDate"
                    placeholder="Enter Position Submission Date"
                    type="date" 
                    ref="positionSubmissionDate"
                  />
                  <small v-if="error.positionSubmissionDate" class="text-danger">{{ error.positionSubmissionDate }}</small>
                </b-form-group>
              </b-col>
              
              <b-col
                md="3"
                xl="3"
                xs="4"
                class="mb-1"
              >
                <b-form-group
                  label="Point Of Contact *"
                  label-for="poc"
                >
                    <b-form-input
                      id="poc"
                      v-model="form.poc"
                      class="text-capitalize"
                      type="text"
                      placeholder="Name of PoC"
                      :state="pocState"
                    />
                    <small v-if="this.error.poc" class="text-danger"> {{ error.poc }}</small>
                </b-form-group>
              </b-col>
              
              <b-col
                md="3"
                xl="3"
                xs="6"
                class="mb-1"
              v-if="form.type === 'Contractual'">
                <b-form-group
                  label="Payroll *"
                  label-for="payroll"

                >
                    <v-select
                      v-model="form.payroll"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="title"
                      :options="payrollOptions"
                      ref="payroll"
                      style="overflow-x: visible"
                      :reduce="(option) => option.title"
                      :disabled="form.type === 'Contractual' || form.type === 'Cost Plus' ? true : false"
                    />
                    <small v-if="this.error.payroll" class="text-danger"> {{ error.payroll }}</small>
                </b-form-group>
              </b-col>
              
              <b-col
                md="2"
                xl="2"
                xs="6"
                class="mb-1"
              >
                
                <b-form-group
                  label="Category *"
                  label-for="category"
                  
                >
                    <v-select
                      v-model="form.category"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="title"
                      :options="categoryOptions"
                      ref="category"
                      style="overflow-x: visible"
                      :reduce="(option) => option.title"
                      :disabled="form.type === 'Contractual' || form.type === 'Cost Plus' ? true : false"
                    />
                    <small v-if="this.error.category" class="text-danger"> {{ error.category }}</small>
                </b-form-group>
              </b-col>
              <b-col
                md="2"
                xl="2"
                xs="6"
                class="mb-1"
              >
                
                <b-form-group
                  label="Vertical *"
                  label-for="vertical"
                  
                >
                    <v-select
                      v-model="form.vertical"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="title"
                      :options="verticalOptions"
                      ref="vertical"
                      style="overflow-x: visible"
                      :reduce="(option) => option.title"
                      :disabled="form.type === 'Contractual' || form.type === 'Cost Plus' ? true : false"
                    />
                    <small v-if="this.error.vertical" class="text-danger"> {{ error.vertical }}</small>
                </b-form-group>
              </b-col>
              <b-col
                md="2"
                xl="2"
                xs="6"
                class="mb-1"
              >
              <b-form-group
                  label="Target Date *"
                  label-for="targetDate"
                  
                >
                    <b-form-datepicker
                      id="targetDate"
                      v-model="form.targetDate"
                      class="mb-1"
                    />
                  
                </b-form-group>
              </b-col>
              <b-col
                md="2"
                xl="2"
                xs="6"
                class="mb-1"
              >
                <b-form-group
                  label="Notice Period *"
                  label-for="noticePeriod"
                >
                  <v-select
                      id="notice-period"
                      v-model="form.noticePeriod"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="title"
                      :options="noticePeriod"
                      ref="np"
                    />
                    <!--<b-form-input
                      id="notice-period"
                      v-model="form.noticePeriod"
                      type="number"
                      ref="np"
                      placeholder="Number of Days"
                    />-->
                    <small v-if="!form.noticePeriod" class="text-danger">{{ error.noticePeriod }}</small>
                 
                </b-form-group>
              </b-col>
              <b-col
                md="2"
                xl="2"
                xs="6"
                class="mb-1"
              >
                <b-form-group
                  label="No of Positions *"
                  label-for="noOfPostion"
                >
                  
                    <b-form-input
                      id="noOfPositions"
                      v-model="form.noOfPositions"
                      type="number"
                      ref="nop"
                      placeholder="Number of Vacancies"
                      :disabled="form.type === 'Contractual' || form.type === 'Cost Plus' ? true : false"
                    />
                    <small v-if="!form.noOfPositions" class="text-danger">{{ error.noOfPosition }}</small>
                 
                </b-form-group>
              </b-col>
              <b-col
                md="2"
                xl="2"
                xs="6"
                class="mb-1"
              >
                <b-form-group
                  label="Min Experience *"
                  label-for="min-exp"
                >
                    <b-form-input
                      id="min-exp"
                      v-model="form.minExp"
                      type="text"
                      inputmode="decimal"
                      placeholder="Exp in years"
                      ref="minexp"
                      :disabled="form.type === 'Contractual' || form.type === 'Cost Plus' ? true : false"
                      @input="onOneDecimalInput('minExp', $event)"
                      @blur="onOneDecimalBlur('minExp')"
                    />
                    <small v-if="error.minExp" class="text-danger">{{ error.minExp }}</small>
                    <small v-else class="text-muted">Up to 1 decimal place (e.g. 1.5)</small>
                </b-form-group>
              </b-col>
              <b-col
                md="2"
                xl="2"
                xs="6"
                class="mb-1"
              >
                <b-form-group
                  label="Max Experience *"
                  label-for="max-exp"
                >                
                    <b-form-input
                      id="max-exp"
                      v-model="form.maxExp"
                      type="text"
                      inputmode="decimal"
                      ref="maxexp"
                      placeholder="Exp in years"
                      :disabled="form.type === 'Contractual' || form.type === 'Cost Plus' ? true : false"
                      @input="onOneDecimalInput('maxExp', $event)"
                      @blur="onOneDecimalBlur('maxExp')"
                    />
                    <small v-if="error.maxExp" class="text-danger">{{ error.maxExp }}</small>
                    <small v-else class="text-muted">Up to 1 decimal place (e.g. 1.5)</small>
                </b-form-group>
              </b-col>
              <b-col
                md="2"
                xl="2"
                xs="6"
                class="mb-1"
              >
                <b-form-group
                  label="Minimum CTC * (Lacs p.a.)"
                  label-for="minCTC"
                >
                    <b-form-input
                      id="min-ctc"
                      v-model="form.minCTC"
                      type="text"
                      inputmode="decimal"
                      ref="minctc"
                      placeholder="e.g. 4"
                      :disabled="form.type === 'Contractual' || form.type === 'Cost Plus' ? true : false"
                      @input="onOneDecimalInput('minCTC', $event)"
                      @blur="onOneDecimalBlur('minCTC')"
                    />
                    <small v-if="error.minCTC" class="text-danger">{{ error.minCTC }}</small>
                    <small v-else class="text-muted">Up to 1 decimal place (e.g. 10.5)</small>
                </b-form-group>
              </b-col>
              <b-col
                md="2"
                xl="2"
                xs="6"
                class="mb-1"
              >
                <b-form-group
                  label="Maximum CTC * (Lacs p.a.)"
                  label-for="maxCTC"
                >
                    <b-form-input
                      id="max-ctc"
                      v-model="form.maxCTC"
                      type="text"
                      inputmode="decimal"
                      ref="maxctc"
                      placeholder="e.g. 5"
                      :disabled="form.type === 'Contractual' || form.type === 'Cost Plus' ? true : false"
                      @input="onOneDecimalInput('maxCTC', $event)"
                      @blur="onOneDecimalBlur('maxCTC')"
                    />
                    <small v-if="error.maxCTC" class="text-danger">{{ error.maxCTC }}</small>
                    <small v-else class="text-muted">Up to 1 decimal place (e.g. 10.5)</small>
                </b-form-group>
              </b-col>
              <b-col
                md="6"
                xl="6"
                xs="6"
                class="mb-1"
              >
              
                <b-form-group
                  label="Desired/Mandatory Skills *"
                  label-for="desiredSkills"
                >
                  <b-form-input
                    v-model="form.skills"
                    placeholder="Enter Skills Comma Separated"
                    type="text"
                    ref="skill"
                    @input="validateDesiredSkills"
                  />
                  <small v-if="!form.skills || error.skills" class="text-danger">{{ error.skills }}</small>
                </b-form-group>
              </b-col>
              
              
            </b-row>
          
        
          <div>
            
            <b-row>
              <b-col
                md="6"
                xl="6"
                xs="6"
                class="mb-1"
              >
              <h5 class="mb-1 mt-1">
              Account Manager
            </h5>
                <b-form-group
                  label="Account Mgr/Team Lead *"
                  label-for="accountMgr"
                >
                  <v-select
                      v-model="form.mgrSelected"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="title"
                      
                      :options="accountMgr"
                      ref="accMgr"
                    />
                  <small v-if="!form.mgrSelected" class="text-danger">{{ error.accMgr }}</small>
                </b-form-group>
              </b-col>
              <b-col
                md="6"
                xl="6"
                xs="6"
                class="mb-1"
              >
              <h5 class="mb-1 mt-1">
              Sourcer
            </h5>
                <b-form-group
                  label="Sourcer *"
                  label-for="sourcer"
                >
                  <v-select
                      v-model="form.sourcerSelected"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="title"
                      multiple
                      :options="recruiters"
                      :close-on-select="false"
                      ref="sourcer"
                    />
                  <small v-if="!form.sourcerSelected" class="text-danger">{{ error.sourcer }}</small>
                </b-form-group>
              </b-col>
            </b-row>
          </div>   
          <div>
            <h5 class="mb-1 mt-1">
              Location & Recruiters
            </h5>
            <b-row>
            <b-col
              md="6"
              xl="6"
              xs="6"
              class="mb-2"
            >
              <b-form-group
                label="City *"
                label-for="city"
              >
                  
                  <b-form-group>
                    <v-select
                      v-model="form.citySelected"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="title"
                      :close-on-select="false"
                      multiple
                      :options="cities"
                      ref="city"
                      :reduce="(option) => option.title"
                    />
                  </b-form-group>
                  <small v-if="!form.citySelected" class="text-danger">{{ error.city }}</small>
               
              </b-form-group>
            </b-col>  
            <b-col
              md="6"
              xl="6"
              xs="6"
              class="mb-1"
            > 
            
              <b-form-group
                label="Recruiters *"
                label-for="recruiters"
              >
                <v-select
                  v-model="form.recruitersSelected"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  multiple
                  :close-on-select="false"
                  label="title"
                  :options="recruiters"
                  ref="recruit"
                />
              <small v-if="!form.recruitersSelected" class="text-danger">{{ error.recruiter }}</small>
              
              </b-form-group>
              
              
            </b-col>
          </b-row>
          </div>
          <div>
            <h5 class="mb-1 mt-1">
              Job Description *
            </h5>
            <b-row>
              <b-col
                cols="12"
                class="mb-2"
              >
                
                <!--<small class="text-muted">Enter Job Description</small>-->
              </b-col>
              <b-col
                cols="12"
                class="mb-2"
              >
                <quill-editor
                  v-model="form.jdContent"
                  :options="snowOption"
                  ref="jd"
                />
                <small class="text-danger" v-if="!form.jdContent || form.jdContent.length < 200 || !validateJDContent(form.jdContent)">{{ error.jd || 'Job description should be of atleast 200 characters' }}</small>
              </b-col>
              
              <b-col
                cols="6"
                xs="12"
                class="mb-2"
              >
              <div>
                  <!-- <div style="float:left">
                    <b-card-text class="mb-1">
                      Is JD Available?
                    </b-card-text>
                    <b-form-checkbox
                      v-model="isJDchecked"
                      checked="true"
                      class="custom-control-primary"
                      name="check-button"
                      switch
                    />
                  </div> -->
                </div>
                <b-form-file
                  name="jdFile"
                  placeholder="Choose a file or drop it here..."
                  drop-placeholder="Drop file here..."
                  @change='openFile'
                  type="file"
                  v-model="form.attachmentsFile"
                  accept="application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/pdf, text/plain, application/rtf, text/markdown, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation"
                />
                <small class="text-danger">{{ error.file }}</small>
                <small v-if="form.file && form.file.size > 1600000" class="text-danger"> File Size Should be less than 1.5 mb </small>
              </b-col>

            </b-row>
          </div>
          
          <!-- Approval Section -->
          <div v-if="isApprovalMode" class="mt-4">
            <h5 class="mb-3">Approval Details</h5>
            <b-row>
              <b-col md="12" class="mb-3">
                <b-form-group label="Review Comments" label-for="approvalComments">
                  <b-form-textarea
                    id="approvalComments"
                    v-model="form.approvalComments"
                    placeholder="Add any comments about changes made or approval decision..."
                    rows="3"
                  />
                </b-form-group>
              </b-col>
              <b-col md="12" class="mb-3">
                <b-form-checkbox
                  v-model="form.reviewConfirmed"
                  name="review-checkbox"
                  value="true"
                  unchecked-value="false"
                >
                  I have reviewed the job and made corrections wherever required
                </b-form-checkbox>
                <small v-if="!form.reviewConfirmed && showReviewError" class="text-danger">
                  Please confirm that you have reviewed the job
                </small>
              </b-col>
            </b-row>
          </div>

          <div>
            <b-row>
              <b-col
              md="12"
              xl="12"
              xs="12"
              class="mb-2"
              >
              <b-button 
                variant="relief-success" 
                value="submit" 
                id="submit" 
                type="submit" 
                width="100%"
                :disabled="isSubmitting"
              >
                {{ isSubmitting ? 'Submitting...' : (isApprovalMode ? 'Approve & Submit' : 'Submit') }}
              </b-button>
              
              </b-col>
            </b-row>
          </div>

      </form>
    </b-card>
  </div>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import { heightTransition } from '@core/mixins/ui/transition'
import Ripple from 'vue-ripple-directive'
import { quillEditor } from 'vue-quill-editor'
import moment from 'moment'
import JobService from '../../../services/job-service'
import UserService from '@/services/user-service'
import jobTimelineService from '@/services/job-timeline'
import clientService from '@/services/client-service'
import domainService from '@/services/domain-service'
import locationService from '@/services/location-service'
import adminConfigService from '@/services/admin-config-service'

import {
  BCard,
  BRow,
  BCol,
  BForm,
  BButton,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BFormDatepicker,
  BFormFile,
  BFormTextarea,
} from 'bootstrap-vue'
//import { required, email } from '@validations'
// import { codeIcon } from './code'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    FormWizard,
    TabContent,
    BRow,
    BCol,
    BCard,
    BForm,
    BButton,
    BFormGroup,
    BFormInput,
    BFormDatepicker,
    vSelect,
    quillEditor,
    BFormFile,
    BFormTextarea,
    BFormInvalidFeedback,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  data() {
    return {
      form:{
        jobId: '',
        id: '',
        jobTitle: '',
        jobBand: '',
        role: '',
        clientSelected: '',
        domainSelected: '',
        poc: '',
        targetDate: '',
        minExp: '',
        maxExp: '',
        minCTC: '',
        maxCTC: '',
        noticePeriod: '',
        noOfPositions: '',
        skillsSelected: '',
        citySelected: '',
        recruitersSelected: '',
        jdContent: '',
        notes: '',
        file: '',
        attachmentsFile: [],
        mgrSelected: '',
        sourcerSelected: '',
        type: '',
        payroll: '',
        category: '',
        vertical: '',
        business: null,
        subBusiness: [],
        jobFunction: null,
        approvalComments: '',
        reviewConfirmed: false,
        driveName: '',
        driveDates: [],
        positionSubmissionDate: '',
      },
      promiseFulfilled: false,
      promiseRejected: false,
      snowOption: {
        theme: 'snow',
      },
      id: '',
      error: {
        title: '',
        client: '',
        domain: '',
        minExp: '',
        maxExp: '',
        minCTC: '',
        maxCTC: '',
        noticePeriod: '',
        noOfPositions: '',
        skills: '',
        city: '',
        recruiter: '',
        sourcer: '',
        jd: '',
        accMgr: '',
        notes: '',
        type: '',
        payroll: '',
        category: '',
        vertical: '',
        jobFunction: '',
        driveName: null,
        positionSubmissionDate: ''
      },
      clients: [],
      domains:[],
      //clients: [{"title":"AXA XL"},{"title":"Accenture"},{"title":"AffinityX"},{"title":"Amazon"},{"title":"Aristocrat"},{"title":"Auto FLow"},{"title":"Concentrix"},{"title":"Course5i"},{"title":"DYNINNO"},{"title":"Deloitte"},{"title":"EXL"},{"title":"Early Salary"},{"title":"Evalueserve"},{"title":"Finaxar"},{"title":"GVR"},{"title":"Genpact"},{"title":"Goldman Sachs"},{"title":"Google"},{"title":"Hexaware"},{"title":"ICICI Housing"},{"title":"IndusInd Bank"},{"title":"Infosys"},{"title":"Intigrity"},{"title":"KPMG Global Services"},{"title":"LTI"},{"title":"LTI RPO"},{"title":"Markets & Markets"},{"title":"Motilal Oswal"},{"title":"Mphasis"},{"title":"OYO Life"},{"title":"Ola Electric"},{"title":"Sapient"},{"title":"Sattva Human Pvt Ltd"},{"title":"Sears"},{"title":"Successive Technologies"},{"title":"Tech Mahindra"},{"title":"Teleperformance"},{"title":"UCB Pharma"},{"title":"UPGRAD"},{"title":"WNS Analytics & BPM"},{"title":"Wipro"},{"title":"Xceedance"},{"title":"eClinicalWorks"}],
      //domains: [{ title: 'IT' }, { title: 'Finance' }, { title: 'Marketing' }, { title: 'Sales' }, { title: 'ITES/BPO' }, { title: 'Finance N Accounting'}, { title: 'Consulting' },{ title: 'Research' },{ title: 'Analytics' }, { title: 'Digital Transformation/Process Excellence/Quality' },{ title: 'EV/Battery' },{ title: 'HROPS' }, { title: 'Talent Acquistion'}, { title: 'HRBP' }],
      recruiters: [],
      accountMgr: [],
      sourcer: [],
      cities: [],
      fcmToken: '',
      noticePeriod: [{title: "Immediate", value: 0}, {title: "0-15", value: 15}, {title: "0-30", value: 30},{title: "0-45", value: 45},{title: "0-60", value: 60}, {title: "0-90", value: 90}],
      fileData: '',
      jobTypeOptions: [{title: "Full Time"}, {title: "Contractual"}, {title: "Fixed Term"}, {title: "Cost Plus"}],
      payrollOptions: [{title: "Client Payroll"}, {title: "Sattva Payroll"}, {title: "Third Party"}],
      categoryOptions: [{title: "White Collar"}, {title: "Blue Collar"}],
      verticalOptions: [{title: "Service Industry"}, {title: "Infra Industry"}],
      businessOptions: [],
      subBusinessOptions: [],
      jobFunctionOptions: [],
      recruitersAssigned: [],
      account_mgrAssigned: [],
      sourcerAssigned: [],
      showReviewError: false,
      isSubmitting: false, // Prevents duplicate submissions while a request is in flight
      isInitialLoadComplete: false, // Guards the clientSelected watcher from firing during the initial data load

      //isJDchecked: true,
    }
  },
  mounted() {
    if(!this.$can('update','jobs')) {
        return
    }

    JobService.getEditJob(this.id).then(res => {
      if (res.status === 200 && res.data.data) {
        const jobData = res.data.data;
        
        // Parse JSON strings to objects
        const parseJsonField = (field) => {
          try {
            return field ? JSON.parse(field) : [];
          } catch (e) {
            console.error(`Error parsing ${field}:`, e);
            return [];
          }
        };

        // Parse all JSON string fields
        const client = parseJsonField(jobData.client);
        const domain = parseJsonField(jobData.domain);
        const recruiters = parseJsonField(jobData.recruiters);
        const accountMgr = parseJsonField(jobData.account_mgr);
        const sourcer = parseJsonField(jobData.sourcer);

        // Split locations into array
        const locations = jobData.locations ? jobData.locations.split(',').map(loc => loc.trim()) : [];

        // Fetch business/sub-business/job-function dropdown data for the job's current client
        // (also re-run via the 'form.clientSelected' watcher if the user changes the client below)
        const clientObj = Array.isArray(client) && client.length ? client[0] : client
        if (clientObj && clientObj.title) {
          this.loadClientDropdownData(clientObj)
        }
        

        // Find matching notice period from options
        const noticePeriod = this.noticePeriod.find(item => item.value === jobData.notice_period) || null;

        // Set form data
        this.form = {
          id: jobData.id,
          jobId: jobData.job_id,
          jobTitle: jobData.position_name,
          role: jobData.role,
          jobBand: jobData.band,
          clientSelected: (this.clients.length && (clientObj || client))
            ? (this.clients.find(c => c.title === (clientObj || client).title) || clientObj || client)
            : (clientObj || client),
          domainSelected: domain,
          noOfPositions: jobData.no_of_vacancies,
          citySelected: locations,
          minCTC: jobData.min_ctc,
          maxCTC: jobData.max_ctc,
          minExp: jobData.min_exp,
          maxExp: jobData.max_exp,
          noticePeriod: noticePeriod,
          skills: jobData.desired_skills,
          mandatory_skills: jobData.mandatory_skills,
          jdContent: jobData.job_description,
          poc: jobData.poc,
          recruitersSelected: recruiters,
          mgrSelected: accountMgr,
          sourcerSelected: sourcer,
          file: jobData.attachments,
          status: jobData.status,
          created_by: parseJsonField(jobData.created_by),
          updated_by: parseJsonField(jobData.updated_by),
          targetDate: jobData.target_date,
          type: jobData.type,
          payroll: jobData.payroll,
          category: jobData.category,
          vertical: jobData.vertical,
          business: jobData.business ? this.parseBusinessData(jobData.business) : null,
          subBusiness: jobData.subBusiness ? this.parseSubBusinessData(jobData.subBusiness) : [],
          driveName: jobData.drive_name || '',
          driveDates: (() => {
            try {
              const raw = jobData.drive_dates
              if (Array.isArray(raw)) return raw.length ? raw : ['']
              if (typeof raw === 'string' && raw) return JSON.parse(raw).length ? JSON.parse(raw) : ['']
            } catch (e) { /* ignore */ }
            return ['']
          })(),
          positionSubmissionDate: jobData.position_submission_date,
          jobFunction: jobData.function,
        };

        // Auto-populate drive name if empty for Reliance clients
        this.$nextTick(() => {
          if (this.isRelianceClient && !this.form.driveName && this.computedDriveName) {
            this.form.driveName = this.computedDriveName
          }
          // Only start reacting to user-driven client changes once the initial load has settled,
          // otherwise the 'form.clientSelected' watcher would immediately wipe out the
          // business/subBusiness/jobFunction values we just populated above.
          this.isInitialLoadComplete = true
        })

        // Store necessary data in component properties
        this.recruitersAssigned = recruiters;
        this.account_mgrAssigned = accountMgr;
        this.sourcerAssigned = sourcer;
        this.fileData = jobData.attachments;

      } else if (res.status === 401 || res.status === 403) {
        // Handle unauthorized access
        window.sessionStorage.setItem('lastPage', window.location.href.split('/#')[1]);
        localStorage.clear();
        this.$router.push({ name: "auth-login" });
      } else {
        // Handle other error cases
        this.form.jobId = res;
      }
    });
    adminConfigService.getJobsDropdownList().then(res=>{
        this.jobStatusOptions = res.data.data.jobStatusList
        this.jobTypeOptions = res.data.data.jobTypeList
        this.categoryOptions = res.data.data.categoryList
        this.payrollOptions = res.data.data.payrollList
        this.verticalOptions = res.data.data.verticalList
    })
    
    
  },
  computed: {
    // Normalize client: v-select stores single object; API/load may give array of one. Use this for .title etc.
    selectedClientObject() {
      const c = this.form.clientSelected
      if (!c) return null
      return Array.isArray(c) && c.length ? c[0] : c
    },
    pocState() {
      // Pure derivation only - the error message itself is kept in sync by the
      // 'form.poc' watcher below (computed getters must not have side effects).
      let regName = /^[a-zA-Z]+ [a-zA-Z]+$/;
      return this.form.poc && !regName.test(this.form.poc) ? 'Please Enter Full Name' : ''
    },
    isKPMGRPOClient() {
      return this.selectedClientObject &&
             this.selectedClientObject.title &&
             this.selectedClientObject.title.includes('KPMG RPO')
    },
    isRelianceClient() {
      if (!this.selectedClientObject || !this.selectedClientObject.title) return false
      const t = this.selectedClientObject.title
      return t === 'Reliance RPO' || t === 'Reliance'
    },
    computedDriveName() {
      if (!this.isRelianceClient) return ''
      const clientName = this.selectedClientObject ? this.selectedClientObject.title : ''
      if (!clientName) return ''

      const typeMap = { 'Full Time': 'Lateral', 'Fixed Term': 'FTE' }
      const driveType = typeMap[this.form.type] || this.form.type || ''

      const monthNames = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']
      const formattedDates = (this.form.driveDates || [])
        .filter(d => d && d.length === 10)
        .map(d => {
          const [yyyy, mm, dd] = d.split('-')
          return `${dd}-${monthNames[parseInt(mm, 10) - 1]}-${yyyy}`
        })

      const domainRaw = this.form.domainSelected
      const domainObj = Array.isArray(domainRaw) ? domainRaw[0] : domainRaw
      const domain = domainObj ? (domainObj.title || domainObj) : ''

      let name = driveType ? `${clientName}-${driveType}` : clientName
      if (formattedDates.length > 0) name += '-' + formattedDates.join(' / ')
      if (domain) name += '-' + domain
      return name
    },
    isApprovalMode() {
      const userData = JSON.parse(localStorage.getItem('userData') || '{}')
      const userRole = userData.role
      const userEmpId = userData.emp_id
      
      // Check if user is manager or has approval permissions
      const canApprove = userRole === 'master' || userRole === 'hr-director' || userRole === 'program-manager'
      
      // Check if job status is pending approval
      const isPendingApproval = this.form.status === 'Approval Pending'
      
      // Check if user is the manager of the job creator
      const isManagerOfCreator = this.isManagerOfJobCreator(userEmpId)
      
      return canApprove && isPendingApproval && isManagerOfCreator
    },
    // form.business is bound to a single-select v-select, so its value is a plain
    // {id, title} object (not an array) once something is selected. Support both
    // shapes defensively so this doesn't silently break if that ever changes.
    hasSelectedBusiness() {
      const b = this.form.business
      if (Array.isArray(b)) return b.length > 0
      return !!(b && b.title)
    },
    filteredSubBusinessOptions() {
      if (!this.hasSelectedBusiness) {
        return []
      }
      const b = this.form.business
      const selectedBusinessIds = Array.isArray(b) ? b.map(business => String(business.id)) : [String(b.id)]
      return this.subBusinessOptions.filter(subBusiness => selectedBusinessIds.includes(String(subBusiness.abbrev)))
    }
  },
  watch: {
    'form.poc'(newVal) {
      let regName = /^[a-zA-Z]+ [a-zA-Z]+$/;
      this.error.poc = newVal && !regName.test(newVal) ? 'Please Enter Full Name' : ''
    },
    'form.clientSelected'(newVal) {
      if (!this.isInitialLoadComplete) return
      const c = Array.isArray(newVal) ? newVal[0] : newVal
      if (c && c.title) {
        this.loadClientDropdownData(c)
        // Reset dependent fields when the user changes the client
        this.form.business = null
        this.form.subBusiness = []
        this.form.jobFunction = null
        if (c.title.includes('Reliance')) {
          if (!this.form.driveDates || this.form.driveDates.length === 0) {
            this.form.driveDates = ['']
          }
        }
      } else {
        this.businessOptions = []
        this.subBusinessOptions = []
        this.jobFunctionOptions = []
      }
    },
    'form.business': {
      handler(newVal, oldVal) {
        // Reset subBusiness selection when business selection changes
        if (newVal !== oldVal) {
          this.form.subBusiness = []
        }
      },
      deep: true
    },
    'form.driveDates': {
      deep: true,
      handler() {
        if (this.isRelianceClient && this.computedDriveName) {
          this.form.driveName = this.computedDriveName
        }
      }
    },
    'form.domainSelected'() {
      if (this.isRelianceClient && this.computedDriveName) {
        this.form.driveName = this.computedDriveName
      }
    },
    'form.type'() {
      if (this.isRelianceClient && this.computedDriveName) {
        this.form.driveName = this.computedDriveName
      }
    }
  },
  created() {

    this.id = this.$route.params.id
    
    
    
    // UserService.getAllUsersDd().then( res => {
    //   if(res.status === "OK") {
    //     console.log("in if")
    //     this.recruiters = res.data.filter(item => item.role === "talent-advisor-sourcer" || item.role === "account-manager" || item.role === "talent-advisor");
    //     this.accountMgr = res.data.filter(item => item.role === "account-manager");
    //     this.sourcer = res.data.filter(item => item.role === "talent-advisor-sourcer" || item.role === "account-manager");
        
    //     console.log(this.recruiters)
    //     console.log(this.accountMgr)
    //     console.log(this.sourcer)
    //   }
    // }).then( d => {
    // console.log(this.recruiters.length, !this.recruiters.length)
    // if ( !this.recruiters.length && !this.accountMgr.length) {
        
    // }
    // })
    UserService.getAllRecruitersList().then(res =>{
        this.recruiters = res.data.filter(item => item.status === 'ACTIVE')
    })
    UserService.getAllManagersList().then(res =>{
      this.accountMgr = res.data.filter(item => item.status === 'ACTIVE')
    })
    clientService.getClients().then(res => {
      this.clients = res.data
    })
    domainService.getDomains().then(res => {
      this.domains = res.data
    })
    locationService.getAll().then(res => {
      this.cities = res.data
    })
    

  },
  destroyed() {
    //window.removeEventListener('resize', this.initTrHeight)
  },
  methods: {
    addDriveDate() {
      this.form.driveDates.push('')
      this.updateDriveName()
    },
    removeDriveDate(i) {
      this.form.driveDates.splice(i, 1)
      this.updateDriveName()
    },
    updateDriveName() {
      if (this.isRelianceClient) {
        this.form.driveName = this.computedDriveName
      }
    },
    loadClientDropdownData(client) {
      if (!client || !client.title) return
      adminConfigService.getClientDropdownList(client.title).then(response => {
        this.businessOptions = response.data.data.businessList || []
        if (response.data.data.atsCollection && Array.isArray(response.data.data.atsCollection)) {
          this.jobFunctionOptions = response.data.data.atsCollection
            .filter(item => item && item.title)
            .map(item => ({ title: item.title }))
        }

        // Process sub-business options to add unique keys and remove duplicates
        const rawSubBusinessOptions = response.data.data.subBusinessList || []
        const uniqueSubBusinesses = new Map()

        rawSubBusinessOptions.forEach((subBusiness, index) => {
          const key = `${subBusiness.abbrev}-${subBusiness.title}`
          if (!uniqueSubBusinesses.has(key)) {
            uniqueSubBusinesses.set(key, {
              ...subBusiness,
              id: index, // Add unique ID to prevent duplicate key errors
              key: key   // Add unique key for Vue
            })
          }
        })

        this.subBusinessOptions = Array.from(uniqueSubBusinesses.values())
      }).catch(error => {
        console.error('Error loading client dropdown data:', error)
      })
    },
    formSubmitted() {
      if(this.isSubmitting) {
        // Guard against duplicate submissions (e.g. double-click) while a request is in flight
        return
      }
      // Check approval requirements
      if (this.isApprovalMode && !this.form.reviewConfirmed) {
        this.showReviewError = true
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Review Required',
            icon: 'AlertCircleIcon',
            variant: 'warning',
          },
        })
        return
      }
      
      const validation = this.validationForm();
      
      if(validation) {
        this.isSubmitting = true
        const formData = new FormData()
        const cities = this.form.citySelected.toString()
        const rid = (this.form.recruitersSelected || []).map(({ id }) => id);
        let sid = ''
        
        if(this.form.sourcerSelected) {
          sid = (this.form.sourcerSelected || []).map(({ id }) => id);
        }
        const aid = [this.form.mgrSelected.id];
        let all_id = [...rid, ...aid, ...sid]
        let uniq_id = [...new Set(all_id)];

        const userData = JSON.parse(localStorage.getItem('userData'));

        const user = `[{"title" : "${userData.first_name} ${userData.last_name}", "emp_id": "${userData.emp_id}"}]`
        const username = `${userData.first_name} ${userData.last_name}`
        const recruiters = JSON.stringify(this.form.recruitersSelected)
        const sourcer = JSON.stringify(this.form.sourcerSelected) ? JSON.stringify(this.form.sourcerSelected) : ''

        let mgr = this.form.mgrSelected
        if(!this.isArray(mgr)) {
          mgr = '[' + JSON.stringify(mgr) + ']'
        } else {
          mgr = JSON.stringify(mgr)
        }
        const clientPayload = this.selectedClientObject ? [this.selectedClientObject] : []
        const client = JSON.stringify(clientPayload) 
        const domain = JSON.stringify(this.form.domainSelected).includes('[') ? JSON.stringify(this.form.domainSelected) : '[' + JSON.stringify(this.form.domainSelected) + ']' 
        formData.append('position_name', this.form.jobTitle)
        formData.append('role', this.form.role)
        formData.append('band', this.form.jobBand)
        formData.append('client', client)
        formData.append('domain', domain)
        formData.append('no_of_vacancies', this.form.noOfPositions)
        formData.append('locations', cities)
        formData.append('target_date', this.form.targetDate)
        formData.append('min_ctc', this.form.minCTC)
        formData.append('max_ctc', this.form.maxCTC)
        formData.append('min_exp', this.form.minExp)
        formData.append('max_exp', this.form.maxExp)
        if(this.form.noticePeriod.value === undefined) {
          formData.append('notice_period', this.form.noticePeriod[0].value)
        }
        else {
          formData.append('notice_period', this.form.noticePeriod.value)
        }
        formData.append('desired_skills', this.form.skills)
        
        formData.append('job_description', this.form.jdContent)
        formData.append('poc', this.form.poc)
        formData.append('recruiters', recruiters)
        formData.append('sourcer', sourcer)
        formData.append('account_mgr', mgr)
        
        // Set status based on approval mode
        const newStatus = this.isApprovalMode ? 'Active' : this.form.status
        formData.append('status', newStatus)
        formData.append('updated_by', user)
        formData.append('type', this.form.type)
        formData.append('payroll', this.form.payroll)
        formData.append('category', this.form.category)
        formData.append('vertical', this.form.vertical)
        const business = this.form.business ? this.form.business.title : ''
        const subBusiness = this.form.subBusiness && this.form.subBusiness.length ? this.form.subBusiness.title : ''
        const jobFunction = this.form.jobFunction ? this.form.jobFunction.title || this.form.jobFunction : ''
        
        formData.append('business', business)
        formData.append('subBusiness', subBusiness)
        formData.append('function', jobFunction)
        formData.append('drive_name', this.form.driveName)
        if (this.form.positionSubmissionDate) {
          // Backend casts this to a timestamptz column; sending '' causes
          // "invalid input syntax for type timestamp with time zone: Invalid date" (500).
          // Only send it when a real date was chosen (e.g. Reliance RPO jobs).
          formData.append('position_submission_date', this.form.positionSubmissionDate)
        }
        if (this.isApprovalMode) {
          formData.append('approvalComments', this.form.approvalComments || '')
        }
        //formData.append('notes', this.form.notes)
        if(this.form.file ) {
          formData.append('jdFile', this.form.file )
        }
        
        JobService.updateJob(this.id, formData).then( res => {
          
          if(res.status === "OK") {

            const userData = JSON.parse(localStorage.getItem('userData'));

            const username = `${userData.first_name} ${userData.last_name}`
          //this.id = res.data.id;
          //console.log("jobid", job_id)
          
            const timelineData = {
              title: `${this.form.jobId} - Job Edited`,
              description: `Some fields were changed`,
              type: "info",
              createdBy: username,
              jobId: this.form.id,
              candidate_id: null
            }
            
            jobTimelineService.create(timelineData).then(res => {
            })
              this.$toast({
                        component: ToastificationContent,
                        props: {
                          title: this.isApprovalMode ? 'Job Approved & Updated' : 'Job Updated',
                          icon: 'EditIcon',
                          variant: 'success',
                        },
                                    
              })  
              //this.$router.push({ name: 'apps-jobs'})
               this.$router.push({ path: '/apps/view-job/' + this.form.id })                    
        } else if ((res.status === 401 ) || (res.status === 403 )) {
            window.sessionStorage.setItem('lastPage', window.location.href.split('/#')[1])
            localStorage.clear();
            this.$router.push({ name: "auth-login" });
        } 
        else {
          this.form.jobId = res
            this.$toast({
                      component: ToastificationContent,
                      props: {
                        title: 'Job Update Failed',
                        icon: 'EditIcon',
                        variant: 'danger',
                      },
            })    
            // this.$router.push({ name: 'apps-jobs'}) 
          }
          
          
        }).catch(err => {
          console.error('Error updating job:', err)
          this.$toast({ component: ToastificationContent, props: { title: 'Something went wrong while updating the job', icon: 'AlertCircleIcon', variant: 'danger' } })
        }).finally(() => {
          this.isSubmitting = false
        })

      }
      
      
    },
    openFile (event) {
        this.form.file = event.target.files[0];
        
    },
    validationForm() {
      this.error = {
        title: '',
        client: '',
        domain: '',
        minExp: '',
        maxExp: '',
        minCTC: '',
        maxCTC: '',
        noticePeriod: '',
        noOfPositions: '',
        skills: '',
        city: '',
        recruiter: '',
        sourcer: '',
        jd: '',
        accMgr: '',
        notes: '',
        type: '',
        payroll: '',
        category: '',
        vertical: '',
        business: '',
        driveName: null
      }
      if (!this.form.jobTitle) {
        this.error.title="Title is Mandatory"
        this.$nextTick(() => {
          this.$refs.title.focus()
        })
        this.$toast({ component: ToastificationContent, props: { title: 'Please fill all required fields', text: this.error.title, icon: 'AlertCircleIcon', variant: 'danger' } })
        return false
      }
      if (!this.form.clientSelected) {
        this.error.client="Client is Mandatory"
        this.$toast({ component: ToastificationContent, props: { title: 'Please fill all required fields', text: this.error.client, icon: 'AlertCircleIcon', variant: 'danger' } })
        return false
      }
      if (this.selectedClientObject && this.selectedClientObject.title && this.selectedClientObject.title.includes('KPMG RPO') && !this.form.business) {
        this.error.business="Business is Mandatory"
        this.$toast({ component: ToastificationContent, props: { title: 'Please fill all required fields', text: this.error.business, icon: 'AlertCircleIcon', variant: 'danger' } })
        return false
      }
      if (!this.form.domainSelected) {
        this.error.domain="Domain is Mandatory"
        this.$toast({ component: ToastificationContent, props: { title: 'Please fill all required fields', text: this.error.domain, icon: 'AlertCircleIcon', variant: 'danger' } })
        return false
      }
      if (!this.form.payroll && this.form.type === 'Contractual') {
        this.error.payroll="Payroll is Mandatory for Contractual Jobs!"
        this.$toast({ component: ToastificationContent, props: { title: 'Please fill all required fields', text: this.error.payroll, icon: 'AlertCircleIcon', variant: 'danger' } })
        return false
      }
      if (!this.form.category ) {
        this.error.category="Category is Mandatory!"
        this.$toast({ component: ToastificationContent, props: { title: 'Please fill all required fields', text: this.error.category, icon: 'AlertCircleIcon', variant: 'danger' } })
        return false
      }
      if (!this.form.vertical ) {
        this.error.vertical="Vertical is Mandatory!"
        this.$toast({ component: ToastificationContent, props: { title: 'Please fill all required fields', text: this.error.vertical, icon: 'AlertCircleIcon', variant: 'danger' } })
        return false
      }
      // Validate job function for Reliance clients
      if (this.isRelianceClient && !this.form.jobFunction) {
        this.error.jobFunction="Job Function is Mandatory for Reliance clients!"
        this.$toast({ component: ToastificationContent, props: { title: 'Please fill all required fields', text: this.error.jobFunction, icon: 'AlertCircleIcon', variant: 'danger' } })
        return false
      }
      if (this.isRelianceClient && !this.form.driveName) {
        this.error.driveName = 'Drive Name is required for Reliance RPO jobs'
        this.$refs.driveName && this.$refs.driveName.focus()
        this.$toast({ component: ToastificationContent, props: { title: 'Please fill all required fields', text: this.error.driveName, icon: 'AlertCircleIcon', variant: 'danger' } })
        return false
      }
      if (this.isRelianceClient && !this.form.positionSubmissionDate) {
        this.error.positionSubmissionDate = 'Position Submission Date is required for Reliance RPO jobs'
        this.$refs.positionSubmissionDate && this.$refs.positionSubmissionDate.focus()
        this.$toast({ component: ToastificationContent, props: { title: 'Please fill all required fields', text: this.error.positionSubmissionDate, icon: 'AlertCircleIcon', variant: 'danger' } })
        return false
      }
      
      let regName = /^[a-zA-Z]+ [a-zA-Z]+$/;
      if(this.form.poc && !regName.test(this.form.poc))
      
      {
        this.$toast({ component: ToastificationContent, props: { title: 'Please fill all required fields', text: 'Please enter a valid full name for Point of Contact', icon: 'AlertCircleIcon', variant: 'danger' } })
        return false
      }
      if (!this.form.minExp) {
        this.error.minExp="Min Exp is Mandatory"
        this.$nextTick(() => {
          this.$refs.minexp.focus()
        })
        this.$toast({ component: ToastificationContent, props: { title: 'Please fill all required fields', text: this.error.minExp, icon: 'AlertCircleIcon', variant: 'danger' } })
        return false
      }
      if (!this.isValidOneDecimal(this.form.minExp)) {
        this.error.minExp = 'Enter a valid number with at most 1 decimal place (e.g. 1.5)'
        this.$nextTick(() => { this.$refs.minexp.focus() })
        this.$toast({ component: ToastificationContent, props: { title: 'Invalid experience', text: this.error.minExp, icon: 'AlertCircleIcon', variant: 'danger' } })
        return false
      }
      if (!this.form.maxExp) {
        this.error.maxExp="Max Exp is Mandatory"
        this.$nextTick(() => {
          this.$refs.maxexp.focus()
        })
        this.$toast({ component: ToastificationContent, props: { title: 'Please fill all required fields', text: this.error.maxExp, icon: 'AlertCircleIcon', variant: 'danger' } })
        return false
      }
      if (!this.isValidOneDecimal(this.form.maxExp)) {
        this.error.maxExp = 'Enter a valid number with at most 1 decimal place (e.g. 1.5)'
        this.$nextTick(() => { this.$refs.maxexp.focus() })
        this.$toast({ component: ToastificationContent, props: { title: 'Invalid experience', text: this.error.maxExp, icon: 'AlertCircleIcon', variant: 'danger' } })
        return false
      }
      if (!this.form.minCTC) {
        this.error.minCTC="Min CTC is Mandatory"
        this.$nextTick(() => {
          this.$refs.minctc.focus()
        })
        this.$toast({ component: ToastificationContent, props: { title: 'Please fill all required fields', text: this.error.minCTC, icon: 'AlertCircleIcon', variant: 'danger' } })
        return false
      }
      if (!this.isValidOneDecimal(this.form.minCTC)) {
        this.error.minCTC = 'Enter a valid amount with at most 1 decimal place (e.g. 10.5)'
        this.$nextTick(() => { this.$refs.minctc.focus() })
        this.$toast({ component: ToastificationContent, props: { title: 'Invalid CTC', text: this.error.minCTC, icon: 'AlertCircleIcon', variant: 'danger' } })
        return false
      }
      if (!this.form.maxCTC) {
        this.error.maxCTC="Max CTC is Mandatory"
        this.$nextTick(() => {
          this.$refs.maxctc.focus()
        })
        this.$toast({ component: ToastificationContent, props: { title: 'Please fill all required fields', text: this.error.maxCTC, icon: 'AlertCircleIcon', variant: 'danger' } })
        return false
      }
      if (!this.isValidOneDecimal(this.form.maxCTC)) {
        this.error.maxCTC = 'Enter a valid amount with at most 1 decimal place (e.g. 10.5)'
        this.$nextTick(() => { this.$refs.maxctc.focus() })
        this.$toast({ component: ToastificationContent, props: { title: 'Invalid CTC', text: this.error.maxCTC, icon: 'AlertCircleIcon', variant: 'danger' } })
        return false
      }
      if (!this.form.noticePeriod) {
        this.error.noticePeriod="Notice Period is Mandatory"
        this.$nextTick(() => {
          this.$refs.np.focus()
        })
        this.$toast({ component: ToastificationContent, props: { title: 'Please fill all required fields', text: this.error.noticePeriod, icon: 'AlertCircleIcon', variant: 'danger' } })
        return false
      }
      if (!this.form.noOfPositions) {
        this.error.noOfPositions="No Of Positions is Mandatory"
        this.$nextTick(() => {
          this.$refs.nop.focus()
        })
        this.$toast({ component: ToastificationContent, props: { title: 'Please fill all required fields', text: this.error.noOfPositions, icon: 'AlertCircleIcon', variant: 'danger' } })
        return false
      }
      if (!this.form.skills || !this.validateDesiredSkills()) {
        this.error.skills="Skills is Mandatory"
        this.$toast({ component: ToastificationContent, props: { title: 'Please fill all required fields', text: this.error.skills, icon: 'AlertCircleIcon', variant: 'danger' } })
        return false
      }
      if (!this.form.citySelected) {
        this.error.city="City is Mandatory"
        this.$toast({ component: ToastificationContent, props: { title: 'Please fill all required fields', text: this.error.city, icon: 'AlertCircleIcon', variant: 'danger' } })
        
        return false
      }
      if (!this.form.recruitersSelected) {
        this.error.recruiter="Recruiter is Mandatory"
        this.$toast({ component: ToastificationContent, props: { title: 'Please fill all required fields', text: this.error.recruiter, icon: 'AlertCircleIcon', variant: 'danger' } })
        
        return false
      }
      if (!this.form.jdContent || this.form.jdContent.length < 200) {
        this.error.jd="JD is Mandatory & should be atleast of 200 characters"
        this.$toast({ component: ToastificationContent, props: { title: 'Please fill all required fields', text: this.error.jd, icon: 'AlertCircleIcon', variant: 'danger' } })
        
        return false
      }
      
      // Validate JD content for meaningful words, not just symbols or repeated characters
      if (!this.validateJDContent(this.form.jdContent)) {
        this.error.jd="JD content must contain meaningful words and proper sentences, not just symbols or repeated characters"
        this.$toast({ component: ToastificationContent, props: { title: 'Please fill all required fields', text: this.error.jd, icon: 'AlertCircleIcon', variant: 'danger' } })
        
        return false
      }
      if (!this.form.mgrSelected) {
        this.error.accMgr="Account Manager/TL is Mandatory"
        this.$toast({ component: ToastificationContent, props: { title: 'Please fill all required fields', text: this.error.accMgr, icon: 'AlertCircleIcon', variant: 'danger' } })
        
        return false
      }
      
      if(this.form.file && this.form.file.size > 1600000 ) {
        this.error.file = null
        if(this.form.file.size > 1600000) {
          this.error.file = "File should not be greater than 1.5MB"
        }
        this.$toast({ component: ToastificationContent, props: { title: 'Please fill all required fields', text: this.error.file, icon: 'AlertCircleIcon', variant: 'danger' } })
        return false
      }
      return true
    },
    isArray(a) {
    return (!!a) && (a.constructor === Array);
    },
    isObject(a) {
    return (!!a) && (a.constructor === Object);
    },
    sanitizeOneDecimalInput(raw) {
      if (raw === null || raw === undefined) return ''
      let s = String(raw).replace(/[^\d.]/g, '')
      if (s.startsWith('.')) s = `0${s}`
      const dotIdx = s.indexOf('.')
      if (dotIdx !== -1) {
        const intPart = s.slice(0, dotIdx)
        const decPart = s.slice(dotIdx + 1).replace(/\./g, '').slice(0, 1)
        s = `${intPart}.${decPart}`
      }
      return s
    },
    onOneDecimalInput(field, value) {
      const raw = typeof value === 'string' ? value : (value && value.target ? value.target.value : value)
      this.form[field] = this.sanitizeOneDecimalInput(raw)
      if (this.error[field]) {
        this.error[field] = ''
      }
    },
    onOneDecimalBlur(field) {
      const val = this.form[field]
      if (val === '' || val === null || val === undefined) return
      let str = String(val).trim()
      if (str.endsWith('.')) {
        str = str.slice(0, -1)
      }
      const num = parseFloat(str)
      if (Number.isNaN(num)) {
        this.form[field] = ''
        return
      }
      const truncated = Math.floor(num * 10) / 10
      this.form[field] = Number.isInteger(truncated) ? String(truncated) : truncated.toFixed(1)
    },
    isValidOneDecimal(value) {
      if (value === '' || value === null || value === undefined) return false
      return /^\d+(\.\d)?$/.test(String(value).trim())
    },
    validateDesiredSkills() {
      this.error.skills = null
      // const regex = /^(?:\s*\w+\s*,){2,}\s*\w+\s*$/;
      const regex = /^(\s*[\w\s]+,\s*){2,}\s*[\w\s]+,?\s*$/
      if(!regex.test(this.form.skills)) {
        this.error.skills = 'Alteast 3 skills required separated by comma'
      }
      return regex.test(this.form.skills);
    },
    parseBusinessData(businessData) {
      try {
        if (typeof businessData === 'string') {
          return JSON.parse(businessData)
        }
        return businessData
      } catch (e) {
        console.error('Error parsing business data:', e)
        return null
      }
    },
    parseSubBusinessData(subBusinessData) {
      try {
        if (typeof subBusinessData === 'string') {
          return JSON.parse(subBusinessData)
        }
        return subBusinessData
      } catch (e) {
        console.error('Error parsing sub-business data:', e)
        return []
      }
    },
    validateJDContent(content) {
      if (!content || typeof content !== 'string') {
        return false;
      }
      
      // Remove HTML tags if content is from rich text editor
      const plainText = content.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
      
      // Split into words and filter out empty strings
      const words = plainText.split(/\s+/).filter(word => word.length > 0);
      
      // Check if content has at least 20 words
      if (words.length < 20) {
        return false;
      }
      
      return true;
    },
    isManagerOfJobCreator(userEmpId) {
      // This is a simplified check - in a real implementation, you'd check the actual manager relationship
      // For now, we'll allow any manager to approve any job
      return true
    },
  },

}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-wizard.scss';
  @import '@core/scss/vue/libs/vue-select.scss';
  @import '@core/scss/vue/libs/quill.scss';
  .repeater-form {
  overflow: hidden;
  transition: .35s height;
}

</style>
